import { createSelector } from '@reduxjs/toolkit';

import { ReduxState } from 'app/redux/types';

import { SubmissionState } from '../constants';
import { RecordOfBigStake, RecordOfEntryErrorType } from '../records';
import { BigStakeErrors, BigStakes } from '../types/bigStakes';
import { selectBigStakesState } from './state';


// ---

export const selectBigStakes = (state: ReduxState): BigStakes => {
  return selectBigStakesState(state).stakes;
};

export const selectBigStakesErrors = (state: ReduxState): BigStakeErrors => {
  return selectBigStakesState(state)?.errors;
};

export const selectBigStakeByDialogId = (
  state: ReduxState,
  dialogId: string,
): RecordOfBigStake | undefined => {
  return selectBigStakes(state).get(dialogId);
};

export const selectBigStakeErrorByDialogId = (
  state: ReduxState,
  dialogId: string,
): RecordOfEntryErrorType | null => {
  return selectBigStakesErrors(state)?.get(dialogId) || null;
};

export const selectStakesWithDecisionSize = createSelector(
  selectBigStakes,
  (bigStakes) => {
    const stakes = [];

    for (const [, stake] of bigStakes) {
      if (
        stake.submission !== SubmissionState.AWAITING
        && stake.submission !== SubmissionState.PROCESSING
      ) {
        stakes.push(stake);
      }
    }

    return stakes.length;
  },
);

export const selectFailedBigStakes = createSelector(
  selectBigStakes,
  (bigStakes) => {
    const stakes = [];

    for (const [, stake] of bigStakes) {
      if (
        stake.submission === SubmissionState.FAILED
        || stake.submission === SubmissionState.REJECTED
      ) {
        stakes.push(stake);
      }
    }

    return stakes;
  },
);

// ---

export const selectVisibleBigStakeInfo = (state: ReduxState): boolean => {
  return selectBigStakesState(state).visibleBigStakeInfo;
};
